import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { ServiceChargesModalComponent } from './modal/service-charges-modal.component';
import { ServiceChargesComponent } from './service-charges.component';
import { ServiceChargesService } from './services/service-charges.service';

@NgModule({
  declarations: [ServiceChargesComponent, ServiceChargesModalComponent],
  imports: [CommonModule, PaginationModule, FormsModule, ReactiveFormsModule],
  exports: [ServiceChargesComponent],
  providers: [ServiceChargesService],
})
export class ServiceChargesModule {}
